import React from 'react';
import PropTypes from 'prop-types';
import Typography from 'Components/UI/Typography';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import ListItem from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/ListItem';


function Step({
  label, classes, onClick, disabled, active,
}) {
  return (
    <ListItem
      button
      key={label}
      elevation={0}
      color="white"
      disabled={disabled}
      className={classes.root}
      onClick={(active || disabled) ? null : onClick}
    >
      <Typography className={classes.label}>{label}</Typography>
    </ListItem>
  );
}

Step.defaultProps = {
  complete: false,
  active: false,
  disabled: false,
  onClick: null,
};

Step.propTypes = {
  label: PropTypes.string.isRequired,
  classes: PropTypes.object.isRequired,
  onClick: PropTypes.func,
  // These are used in the Styles below
  // eslint-disable-next-line react/no-unused-prop-types
  complete: PropTypes.bool,
  active: PropTypes.bool,
  // eslint-disable-next-line react/no-unused-prop-types
  disabled: PropTypes.bool,
};

export default withStyles(theme => ({
  root: {
    borderRadius: theme.radius.md,
    backgroundColor: theme.palette.common.white,
    padding: theme.spacing(2),
    justifyContent: 'flex-start',
    backgroundClip: 'padding-box',
    borderLeft: props => {
      if (props.active) {
        return `4px solid ${theme.palette.facet.accentBlue3}`;
      }
      return 'unset';
    },
    cursor: props => ((props.disabled || props.active) ? 'not-allowed' : 'pointer'),
    '&:hover': {
      backgroundColor: theme.palette.facet.accentBlue15,
    },
    '&:hover $label': {
      textDecoration: `underline ${theme.palette.primary.main}`,
      color: theme.palette.primary.main,
    },
  },
  label: {
    fontSize: 18,
    fontWeight: theme.typography.fontWeightFacetBold,
    paddingLeft: theme.spacing(1),
    color: props => {
      if (props.active) return theme.palette.facet.accentBlue;
      if (props.complete) return theme.palette.primary.main;

      return theme.palette.facet.darkGray;
    },
  },
}))(Step);
